import { useState , useRef, useEffect} from "react";
import { Row, Col, Button } from "react-bootstrap"
import { Card, ListGroup } from "react-bootstrap"
import AddEditClientContacts from "./EditSections/AddEditClientContacts";
import { right } from "@popperjs/core";
import Icon from "../Icon/Icon";
import { FcHome  } from "react-icons/fc";


const CustomerContacts = ({data, ShowClientAddress}) => {

    const[showAdd, setShowAdd] = useState(false);
    const[showEdit, setShowEdit] = useState(false);
    const[ProcessData, setdata] = useState(data.customerContacts);
    const[action, setAction] = useState("add");
    const[DatatoEdit, setDateToEdit] = useState(null);
    const[bShowClientAddress, setShowClientAddress] = useState(false);


    
   // const CurrentDataObj = useRef({data : null});

    function handleAddClick(){
        setAction("add");
        setShowAdd(true);
        setShowEdit(false);
    }

    const editEventClicked=(data2)=>{
        setDateToEdit(data2);
    //console.log(data2);
        setAction("edit");
        setShowAdd(false);
        setShowEdit(true);
    }

    useEffect(()=>{
        setShowClientAddress(ShowClientAddress);
    },[]);

    const fulladdress = data.companyAdd1 +', '+ data.companyAdd2 +', '+ data.companyAdd3 +', '+ data.companyAdd4 +', '+ data.postcode;

  return (
    <>
    <Row>
    <div className="col-md-12">
        <Card>
            <Card.Header><FcHome /> &nbsp; Contact Details<span style={{float:right}}><Button variant="outline-primary" size="sm" onClick={handleAddClick}>+ New Contact</Button></span></Card.Header>
            <ListGroup variant="flush">

                {bShowClientAddress && 
                <ListGroup.Item>                    
                <b>Client Address</b><br></br><span className="text">{fulladdress}</span>
                <br></br>T : {data.companyTelNo}
                <br></br>E : {data.emailAddress}                   
                </ListGroup.Item>}

                {/* {ProcessData.customerContacts.map(cn=>( */}
                {ProcessData.map(cn=>(      
                <>                
                <ListGroup.Item key={cn.id}>            
                    <b>{cn.relationship}</b>
                    <br></br>{cn.name}
                    <br></br><span className="text">{cn.add1 +', '+ cn.add2 +', '+ cn.add3 +', '+ cn.add4 +', '+ cn.postcode}</span>
                    <br></br><Icon name="call-fill"/> {cn.phone}
                    <br></br><Icon name="emails-fill"/> {cn.email}   
                    <br></br><Icon name="mobile"/> {cn.mobile}   
                    <br></br>Relationship : {cn.relationship}   
                    <br></br>Live with Client : {cn.liveWithClient==1? 'Yes' : 'No'}  
                    <span><Button style={{float:"right"}} variant="outline-primary" size="sm" onClick={()=>editEventClicked(cn)} ><Icon name="pen"></Icon>&nbsp;Edit</Button></span>                          
                </ListGroup.Item>
                                                  
                
                </> 
                ))}
            </ListGroup>
        </Card>
    </div>
    </Row>

   {showAdd && <AddEditClientContacts show={showAdd} action={action} CustomerId={data.customerId} setShowAddEdit={setShowAdd} data={ProcessData} setdata={setdata}/>   } 
   {showEdit && <AddEditClientContacts show={showEdit} action={action} CustomerId={data.customerId} setShowAddEdit={setShowEdit} data={DatatoEdit} fulldata={ProcessData} setdata={setdata}/>}
    </>
  )
}

export default CustomerContacts